import { CONSUMER_APP_SOURCE } from '@upflowy/types';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { EVENT_TYPE_REDIRECT } from '../helpers';
import { isStandalone } from '../helpers/is-standalone';
import { addHttps } from '../helpers/utils';

export const useRedirect = () => {
  const router = useHistory();

  return useCallback(
    (link: string) => {
      const url = new URL(window.location.toString());

      const linkUrl = new URL(link, window.location.origin);

      const containerId = url.searchParams.get('containerId');
      const mode = isStandalone(url);
      const origin = url.searchParams.get('origin');

      if (mode === 'embedded') {
        window.parent.postMessage(
          {
            source: CONSUMER_APP_SOURCE,
            containerId,
            redirectUrl: addHttps(link),
            type: EVENT_TYPE_REDIRECT,
          },
          origin ?? '',
        );

        return;
      }

      // For some wacky reason, the `router` variable can be undefined during the if condition but available
      // within the block. For this reason we do a try/catch so we can utilise it if available within the block.
      if (linkUrl.origin === window.location.origin) {
        try {
          router.push(`${linkUrl.pathname}${linkUrl.search}`);
        } catch (e) {
          window.location.href = addHttps(link);
        }

        return;
      }

      window.location.href = addHttps(link);
    },
    [router],
  );
};
